export default __webpack_public_path__ + "7da16d7c73b9ed5bb929603f0069c253.png";